'use strict';

import 'whatwg-fetch';
import TileLayer from 'ol/layer/Tile';
import TileWMSSource from 'ol/source/TileWMS';
import WMTSSource from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import Projection from 'ol/proj/Projection';

import WMTSCapabilities from 'ol/format/WMTSCapabilities';

import { getWidth } from 'ol/extent';
import { get as getProjection } from 'ol/proj';
import SettingsInstance from './../api/SettingsInstance';
export default class MapBackgrounds {
  async getBaseMap() {
    let tileSize = [512, 512];
    let origin = [0, 0];

    let params = {
      REQUEST: 'GetCapabilities',
      SERVICE: 'WMTS'
    };

    let url = this.fillUrl(
      'https://mapy.geoportal.gov.pl/wss/service/WMTS/guest/wmts/ORTO',
      params
    );

    let resolutions = [];

    try {
      let response = await fetch(url);
      let text = await response.text();

      let parser = new WMTSCapabilities();

      let tileMatrix = parser.read(text).Contents.TileMatrixSet[0].TileMatrix;
      let standardizedRenderingPixelSize = 0.00028;

      resolutions = tileMatrix.map(x => {
        tileSize[0] = x.TileWidth;
        tileSize[1] = x.TileHeight;

        origin[0] = x.TopLeftCorner[1];
        origin[1] = x.TopLeftCorner[0];

        let widthPixel = x.TileWidth * x.MatrixWidth;
        var heightPixel = x.TileHeight * x.MatrixHeight;

        var right =
          x.ScaleDenominator * widthPixel * standardizedRenderingPixelSize +
          x.TopLeftCorner[1];
        var bottom =
          x.TopLeftCorner[0] -
          x.ScaleDenominator * heightPixel * standardizedRenderingPixelSize;

        var maxResolutionW = Math.round(
          ((right - x.TopLeftCorner[1]) / widthPixel) * Math.pow(10, 13)
        );
        var maxResolutionH = Math.round(
          ((x.TopLeftCorner[0] - bottom) / heightPixel) * Math.pow(10, 13)
        );

        if (maxResolutionW !== maxResolutionH) {
          throw new Error('Could not calculate ');
        }

        return maxResolutionW / Math.pow(10, 13);
      });
    } catch (e) {
      var proj2180 = getProjection('EPSG:2180');
      var maxResolution = getWidth(proj2180.getExtent()) / 512;

      for (var i = 0; i < 16; i++) {
        resolutions[i] = maxResolution / Math.pow(2, i);
      }
    }

    let matrixIds = resolutions.map((x, i) => i);

    return new TileLayer({
      source: new WMTSSource({
        url: 'https://mapy.geoportal.gov.pl/wss/service/WMTS/guest/wmts/ORTO',
        matrixSet: 'EPSG:2180',
        format: 'image/png',
        projection: new Projection({
          code: 'EPSG:2180',
          units: 'm',
          axisOrientation: 'neu'
        }),
        tileGrid: new WMTSTileGrid({
          tileSize: tileSize,
          origin: origin,
          resolutions: resolutions,
          matrixIds: matrixIds
        }),
        style: 'default',
        wrapX: true
      })
    });
  }

  async getOverviewMapBackground() {
    let coordinateSystem = 'EPSG:2180';
    let tileSize = [512, 512];
    let origin = [0, 0];

    let resolutions = [];

    try {
      const url =
        SettingsInstance.geoserverUrl +
        '/gwc/service/wmts?REQUEST=GetCapabilities&SERVICE=WMTS';
      let layerCapabilities = null;
      if (window.wmtsLayersCapabilities) {
        const foundItem = window.wmtsLayersCapabilities.find(
          wmtsLayersSource => wmtsLayersSource.url === url
        );
        if (foundItem) {
          // Create a copy of the layer source using Object.assign() or the spread operator
          layerCapabilities = foundItem.layerCapabilities;
        }
      }
      if (!layerCapabilities) {
        let response = await fetch(url).text();
        const parser = new WMTSCapabilities();
        layerCapabilities = parser.read(response.body);

        if (!window.wmtsLayersCapabilities) {
          window.wmtsLayersCapabilities = [];
        }
        window.wmtsLayersCapabilities.push({
          url: url,
          layerCapabilities: layerCapabilities
        });
      }
      let tileMatrix = layerCapabilities.Contents.TileMatrixSet[0].TileMatrix;
      let standardizedRenderingPixelSize = 0.00028;

      resolutions = tileMatrix.map(x => {
        tileSize[0] = x.TileWidth;
        tileSize[1] = x.TileHeight;

        origin[0] = x.TopLeftCorner[1];
        origin[1] = x.TopLeftCorner[0];

        let widthPixel = x.TileWidth * x.MatrixWidth;
        var heightPixel = x.TileHeight * x.MatrixHeight;

        var right =
          x.ScaleDenominator * widthPixel * standardizedRenderingPixelSize +
          x.TopLeftCorner[1];
        var bottom =
          x.TopLeftCorner[0] -
          x.ScaleDenominator * heightPixel * standardizedRenderingPixelSize;

        var maxResolutionW = Math.round(
          ((right - x.TopLeftCorner[1]) / widthPixel) * Math.pow(10, 13)
        );
        var maxResolutionH = Math.round(
          ((x.TopLeftCorner[0] - bottom) / heightPixel) * Math.pow(10, 13)
        );

        if (maxResolutionW !== maxResolutionH) {
          throw new Error('Could not calculate ');
        }

        return maxResolutionW / Math.pow(10, 13);
      });
    } catch (e) {
      var proj2180 = getProjection('EPSG:2180');
      var maxResolution = getWidth(proj2180.getExtent()) / 512;

      for (var i = 0; i < 16; i++) {
        resolutions[i] = maxResolution / Math.pow(2, i);
      }
    }

    let matrixIds = resolutions.map((x, i) => i);

    return new TileLayer({
      source: new WMTSSource({
        url: 'https://mapy.geoportal.gov.pl/wss/service/WMTS/guest/wmts/BDOO',
        layer: 'BDOO',
        matrixSet: coordinateSystem,
        format: 'image/png',
        projection: new Projection({
          code: coordinateSystem,
          units: 'm',
          axisOrientation: 'neu'
        }),
        tileGrid: new WMTSTileGrid({
          tileSize: tileSize,
          origin: origin,
          resolutions: resolutions,
          matrixIds: matrixIds
        }),
        style: 'default',
        wrapX: true
      })
    });
  }

  fillUrl(url, params) {
    let queryStringIndex = url.indexOf('?');

    if (queryStringIndex >= 0) {
      url = url.substr(queryStringIndex);
    } else {
      url += '?';
    }

    for (var param in params) {
      url = url + param + '=' + params[param] + '&';
    }

    url = url.slice(0, -1);

    return url;
  }
}
